import {Wallet} from "./wallet";

export class CustomerAccount {

  _id: string;
  email: string;
  name: string;
  businessId: string;
  userId: string;

  wallet: Wallet;

  constructor(customerAccountData?: any) {
    if(customerAccountData) {
      this._id = customerAccountData._id;
      this.email = customerAccountData.email;
      this.name = customerAccountData.name;
      this.userId = customerAccountData.userId;
      this.businessId = customerAccountData.businessId;
      this.wallet = customerAccountData.wallet ? new Wallet(customerAccountData.wallet) : null;
    }
  }
}
